
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./main": () => {
return Promise.all([__webpack_require__.e("541"), __webpack_require__.e("665"), __webpack_require__.e("225"), __webpack_require__.e("802")]).then(() => (() => (__webpack_require__(3935))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };